var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDnaHeartProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5393D;}\n\t.st1{fill:#AA1A18;}\n\t.st2{fill:none;stroke:#F8EEE1;stroke-width:4.9435;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.8c42.7,0,77.3-34.3,77.3-76.6S149,30.6,106.3,30.6S29,64.9,29,107.2S63.6,183.8,106.3,183.8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.8,94.4c-0.1-13.7-10.4-24.6-22.9-24.5s-22.5,11.3-22.3,25c-0.1-13.7-10.4-24.6-22.9-24.5 s-22.5,11.3-22.3,25c0,4.2,1.2,8.4,3,12.5c0,0.1,0,0.2,0,0.2c0,0.5,0.1,1,0.2,1.4l0,0v0.1c0.3,1.4,1,2.5,1.9,3.4h-0.9 c11.3,21.9,41.7,40.9,41.7,40.9s29.9-19.6,40.7-41.7h-1c0.8-1,1.4-2.2,1.5-3.9c0-0.1,0-0.1,0-0.2h0.2 C150.7,103.6,151.9,99,151.8,94.4z"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "56.6,111 85.4,110.4 89.7,98.7 101.7,130.4 109.8,104.4 114.5,117.4 123,103.2 126.2,115.1  128.1,110.6 152.7,110.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaHeartProfile);
export default __webpack_public_path__ + "static/media/DNA_Heart_Profile.7076d7072927c13fd6ffdc3bd892e4aa.svg";
export { ForwardRef as ReactComponent };